<template>
  <div
    id="contact-search"
    class="flex column" >
    <!-- New conversation -->
    <!-- <template v-if="searchValueIsNumber && !fullMatch"> -->
    <!--<template v-if="searchValueIsNumber">  TODO previous line is correct. This one is for testing!!! -->
      <!-- <h5>New conversation</h5>
      <span
        id="new-number"
        class="contact-item flex flex-align-center"
        :class="{error: !phoneValid}"
        @mouseover="newNumberMouseover"
        @mouseout="newNumberMouseout"
        @click="validatePhoneNumber">
        <SBAvatar
          :show-client="true"
          :person="null"
          :size="UserDropdownButtonSize.L"
          class="" />
        <b class="wrap-anywhere">{{ searchQuery | phoneFormat }}</b>
        <SBIcon
          v-if="!phoneValid"
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="12" />
        <b-popover
          ref="newNumberPopoverRef"
          target="new-number"
          triggers="manual"
          placement="bottom"
          custom-class="no-pointer-events" >
          <h1 class="error-color">Phone number format is wrong</h1>
          <p>You must use a phone number in full international
            format that includes a plus sign (+)
            followed by the country code, city
            code, and local phone number.</p>
          <p>For example, if a contact in the United
            Kingdom (country code "44") has the
            area code "020" and phone number
            "XXX-XXXX", you'd enter
            +44 020 XXX XXXX.</p>
        </b-popover>
      </span>
    </template> -->

    <!-- Contact list -->
    <template v-if="loadingOrganisationContacts || (!searchQuery && organisationContactList.data.length) || (searchQuery && organisationContactList.data.length)">
      <ScrollArea
        id="contact-search"
        ref="contactsSearchScrollbar"
        class="pt-3 pb-3"
        @bottom="loadMoreResults">
        <template v-if="organisationContactList.data.length">
          <!-- TODO Conversation header has listener fow keys. Make this more generic and allow minus values so prelist items can be added. Also think about post list items. -->
          <div
            class="contact-item broadcast-btn flex flex-align-center"
            :class="{selected: startNewConversationSelectId === 0}"
            @mousemove="setStartNewConversationSelectId(0)"
            @click="startBroadcast" >
            <SBIcon
              :icon="SBIconList.BROADCAST"
              :color="SBColors.bluePrimary"
              background-color="#f7fbff"
              border-color="#dce5ef"
              :border-width="1"
              :border-radius="50"
              :size="16"
              :hover-size="34" />
            <p>New broadcast</p>
          </div>
        </template>
        <div
          v-for="(contact, index) in organisationContactList.data"
          :key="index"
          class="contact-item flex flex-align-center align-stretch"
          :class="{selected: startNewConversationSelectId === index + 1}"
          @mousemove="setStartNewConversationSelectId(index + 1)"
          @click="loadConversation(contact)" >
          <SBAvatar
            :show-client="true"
            :person="contact"
            :character-count="1"
            :size="UserDropdownButtonSize.L"
            class="" />
          <div
            class="flex column space-between"
            :class="{'self-center': !contact.name}">
            <h2>{{ contact.name ? contact.name : contact.phone | phoneFormat }}</h2>
            <p v-if="contact.name">{{ contact.phone | phoneFormat }}</p>
          </div>
        </div>
        <Spinner
          v-if="loadingOrganisationContacts"
          class="mb-4 mt-3"
          :thickness="2" />
        <p
          v-if="Object.keys(api_error).length"
          class="error">Error loading contacts</p>
      </ScrollArea>
    </template>

    <div
      v-if="!loadingOrganisationContacts && !searchQuery && !organisationContactList.data.length"
      class="no-results" >
      <p><span class="emoji-fix mr-2">ℹ️</span>Start typing a phone number</p>
    </div>

    <!-- No results -->
    <!-- TODO this can be a component, it is used on multiple places.... here, Conversations... -->
    <div
      v-if="(!loadingOrganisationContacts && searchQuery && !organisationContactList.data.length) && (!searchValueIsNumber && !fullMatch)"
      class="no-results" >
      <p><span class="emoji-fix">😐</span> No contacts matched your search.</p>
      <!-- <b>{{ searchQuery | phoneFormat }}</b> -->
    </div>

    <div
      v-if="!loadingOrganisationContacts && searchQuery && !organisationContactList.data.length && searchValueIsNumber"
      class="no-results number" >
      <p>Start a conversation with <b>{{ startConversationNumberInternational }}</b> by pressing enter.</p>
      <span
        class="enter flex center-all"
        @click="simulateEnterPress">
        <SBIcon
          :icon="SBIconList.ENTER"
          :color="SBColors.blackLight"
          :size="8" />
        Enter
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { parsePhoneNumberFromString, parsePhoneNumber } from 'libphonenumber-js';

import ScrollArea from '@/components/common/ScrollArea';
import Spinner from '@/components/common/Spinner';
import UserDropdownButtonSize from '../../../../helpers/lists/userDropdownButtonSize';
import SBAvatar from '../../../common/Avatar';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import randomString from '@/helpers/randomString';
import JuneMixin from '@/mixins/June';

export default {
  name: 'ContactSearch',
  components: {
    ScrollArea,
    Spinner,
    SBAvatar,
    SBIcon,
  },
  mixins: [
    JuneMixin,
  ],
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    branchId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      phoneValid: true,
      UserDropdownButtonSize,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      loadingOrganisationContacts: 'contact/loadingOrganisationContacts',
      organisationContactList: 'contact/organisationContactList',
      templateMessageList: 'notification/templateMessageList',
      templateMessagesLoaded: 'notification/templateMessagesLoaded',
      startNewConversationSelectId: 'chat/startNewConversationSelectId',
      startConversationNumber: 'chat/startConversationNumber',
      userId: 'user/id',
      enterPressed: 'chat/enterPressed',
      userRegion: 'user/region',
      api_error: 'contact/apiError',
    }),
    searchValueIsNumber() {
      const regex = /^[+\-()0-9]+$/;
      return regex.test(this.searchQuery.replaceAll(' ', ''));
    },
    fullMatch() {
      return this.organisationContactList.data.find(contact => contact.phone === this.searchQuery);
    },
    startConversationNumberInternational() {
      return parsePhoneNumber(this.searchQuery, this.userRegion).formatInternational();
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      this.phoneValid = true;
      if (this.searchQuery && !this.organisationContactList.data.length && oldValue.trim() && newValue.startsWith(oldValue)) {
        // Do not make additional search requests if there is no data for the previous search string and new one starts exactly as previous string.
        this.setAllowEnter(true);
        return;
      }
      this.loadContacts();
    },
    startConversationNumber() {
      this.setFolder('open');
      if (/^index/.test(this.startConversationNumber)) {
        this.loadConversation(this.organisationContactList.data[this.startNewConversationSelectId]);
      } else if (this.organisationContactList.data.length === 1 && this.organisationContactList.data[0].phone === this.startConversationNumber) {
        this.loadConversation(this.organisationContactList.data[0]);
      } else {
        this.createNewConversation();
      }
    },
    enterPressed() {
      if (this.startNewConversationSelectId !== null) {
        if (this.startNewConversationSelectId === 0) {
          this.startBroadcast();
          return;
        }
        this.loadConversation(this.organisationContactList.data[this.startNewConversationSelectId - 1]);
      }
    },
    loadingOrganisationContacts() {
      if (this.loadingOrganisationContacts) {
        this.setAllowEnter(true);
      } else if (this.organisationContactList.data.length) {
        this.setStartNewConversationSelectId(0);
      }
    },
    organisationContactList() {
      if (this.organisationContactList && this.organisationContactList.data && this.organisationContactList.data.length) {
        this.setAllowEnter(true);
      }
    },
  },
  mounted() {
    this.loadContacts();
    this.fetchTemplateMessages({ businessId: this.branchId, data: { limit: 3000 } });
  },
  beforeDestroy() {},
  methods: {
    ...mapActions({
      addTempConversation: 'chat/addTempConversation',
      fetchOrganisationContacts: 'contact/fetchOrganisationContacts',
      fetchTemplateMessages: 'notification/fetchTemplateMessages',
      resetOrganisationContacts: 'contact/resetOrganisationContacts',
      setStartNewConversationSelectId: 'chat/setStartNewConversationSelectId',
      addNewTempConversation: 'chat/addNewTempConversation',
      setAllowEnter: 'chat/setAllowEnter',
      setFolder: 'chat/setFolder',
      setActiveConversation: 'chat/setActiveConversation',
      resetConversationsLoad: 'chat/resetConversationsLoad',
    }),
    loadContacts(page = 1) {
      if (page === 1) {
        this.resetOrganisationContacts();
      }
      this.fetchOrganisationContacts({
        organisationId: this.currentOrganisation.id,
        data: {
          conversations_business: this.branchId,
          limit: 50,
          page,
          search_query: this.searchQuery,
        },
      });
    },
    loadConversation(contact) {
      if (!contact.conversation_id || contact.conversation_id === 'None') {
        this.createNewConversation(contact);
      } else {
        this.setActiveConversation({
          business_id: this.branchId,
          id: contact.conversation_id,
          user_id: contact.conversation_user_id,
          folder: contact.conversation_folder === 'DO' ? 'done' : 'open',
          contact,
        });
        this.$router.push({
          name: 'OrganisationBusinessConversation',
          params: {
            organisationId: this.$route.params.organisationId,
            businessId: this.branchId,
            conversationId: contact.conversation_id,
            preselectFolder: contact.conversation_folder,
            selectConversation: true,
          },
        });
      }

      this.$nextTick(() => {
        this.$eventBus.$emit('close-new-conversation-bar');
      });
    },
    loadMoreResults() {
      if (this.organisationContactList.meta.current_page < this.organisationContactList.meta.last_page) {
        this.loadContacts(this.organisationContactList.meta.current_page + 1);
      }
    },
    newNumberMouseout() {
      this.$refs.newNumberPopoverRef.$emit('close');
    },
    newNumberMouseover() {
      if (!this.phoneValid && this.$refs.newNumberPopoverRef) {
        this.$refs.newNumberPopoverRef.$emit('open');
      }
    },
    validatePhoneNumber() {
      const parsedPhone = parsePhoneNumberFromString(this.searchQuery);

      // message: 'Phone format is wrong',
      this.phoneValid = !!(
        parsedPhone &&
        parsedPhone.country &&
        ((parsedPhone.number.length - parsedPhone.countryCallingCode.length - 1) > 5)
      );

      if (this.phoneValid) {
        this.createNewConversation();
      } else {
        // To show the popover for invalid number
        this.$nextTick(() => {
          this.newNumberMouseover();
        });
      }
    },
    createNewConversation(contact = null) {
      const newConversation = {
        id: `TEMP-conversation-${randomString()}`,
        folder: 'open',
        phone: contact && contact.phone ? contact.phone : this.startConversationNumber,
        name: contact && contact.name ? contact.name : '',
        inbound_sent_at: null,
        message_sent_at: this.$moment(),
        user_id: this.userId,
        seen: true,
        assignment_seen: true,
        businessId: this.branchId,
      };
      this.addNewTempConversation(newConversation);

      this.$eventBus.$emit('close-new-conversation-bar');
    },
    simulateEnterPress() {
      this.$eventBus.$emit('simulate-enter-pressed');
    },
    startBroadcast() {
      this.juneTrack('Broadcast start', { from: 'New message button' });
      this.$router.push({
        name: 'OrgContacts',
        params: {
          organisationId: this.$route.params.organisationId,
          broadcast: true,
          broadcastNumberId: this.$route.params.businessId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#contact-search {
  height: 100%;

  h5 {
    margin: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    color: $blackUltralight;
    position: relative;

    &:first-of-type {
      margin-top: 12px;
    }
  }

  .contact-item {
    min-height: 36px;
    margin: 0 12px 0 12px;
    padding: 8px;
    border-radius: 5px;

    line-height: 1.2;
    color: $blackPrimary;
    cursor: pointer;

    * {
      pointer-events: none;
      font-size: 14px;
      font-weight: 400;
    }

    &.error {
      color: $redPrimary;
    }

    p {
      color: $blackUltralight;
    }

    .sb-avatar {
      margin-right: 6px;
    }

    .sb-icon:last-child {
      margin-left: 5px;
    }

    &.selected {
      background-color: $greyChatBubble;
    }
  }

  .broadcast-btn {
    padding: 8px;
    margin: 0 12px;

    p {
      margin-left: 6px;
      color: $blackPrimary;
    }
  }

  .no-results {
    margin: 27px 20px 0;
    text-align: center;
    color: $blackLight;

    p, b, span {
      font-size: 14px !important;
      line-height: 1.21 !important;
    }

    &.number {
      color: $blackLight !important;
    }

    .enter {
      font-size: 12px !important;
      font-weight: 500 !important;
      color: $blackLight !important;
      border-radius: 5px;
      border: solid 1px $blackUltralight;
      background-color: $greyUltralight;
      padding: 2px 8px;
      width: fit-content;
      margin: 10px auto;
      cursor: pointer;

      .sb-icon {
        margin-right: 5px;
      }
    }
  }

  .scroll-container {
    .error {
      color: $redPrimary;
      padding: 12px;
      text-align: center;
    }
  }
}

.popover {
  p {
    color: #2a383f;
  }
}
</style>
